import { enc, SHA256 } from 'crypto-js';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TextField from '../components/TextField';
import { useAuth } from '../auth-context';
import { toast } from "react-toastify";
import { baserUrl } from "../typings";

function LoginPage() {
    const { setToken } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const onLogin = () => {
        fetch(`${baserUrl}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password: encrypt(password), organisationId: 152 })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.text();
                }
                return res.text().then(t => Promise.reject(t));
            })
            .then(token => {
                setToken(token);
                navigate('/files');
            }).catch((e) => {
                console.log(e);
                toast.error(e || 'Login failed');
        });
    };

    const encrypt = (password: string) => {
        const hash = toAsciiBytes(SHA256(password).toString(enc.Latin1));
        const encrypted = toAsciiString(hash);
        return btoa(unescape(encodeURIComponent(encrypted)));
    };

    const toAsciiBytes = (str: string) => {
        const bytes = [];
        for (let i = 0; i < str.length; ++i) {
            bytes.push(str.charCodeAt(i));
        }
        return bytes;
    }

    const toAsciiString = (buffer: any) => {
        let result = '';
        for (let i = 0; i < buffer.length; ++i) {
            if (buffer[i] > 127) {
                result += '?';
            } else {
                result += String.fromCharCode(buffer[i]);
            }
        }
        return result;
    }

    return (
        <div className="container">

            <div className="title">Portal Login</div>

            <div className="box" style={{gap: '12px'}}>

                <TextField
                    label="Username"
                    placeholder="Enter your username"
                    value={username}
                    setValue={setUsername}
                />

                <TextField
                    type="password"
                    label="Password"
                    placeholder="Enter your password"
                    value={password}
                    setValue={setPassword}
                />

                <button className="my-button" onClick={onLogin}>LOGIN</button>

            </div>

        </div>
    );
}

export default LoginPage;
